export type PurchaserConfigTemplateFormValues = {
  metadata: string;
  searchKeywords: string;
  intelligenceFilter: string;
  deductionTypeInvoicePatternForDiscount: string;
  additionalFieldMapping: string;
  discountTermAgreementDaysTolerance: string;
};

export const EMPTY_CONFIG_TEMPLATE_FORM_VALUES: PurchaserConfigTemplateFormValues =
  {
    metadata: "",
    searchKeywords: "",
    intelligenceFilter: "",
    deductionTypeInvoicePatternForDiscount: "",
    additionalFieldMapping: "",
    discountTermAgreementDaysTolerance: "",
  };

export function formatJsonForTextarea(value: unknown): string {
  if (value == null || value === "") {
    return "";
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return "";
    try {
      return JSON.stringify(JSON.parse(trimmed), null, 2);
    } catch {
      return value;
    }
  }
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return "";
  }
}

/** Empty → null; invalid JSON throws with message. */
export function parseOptionalJsonField(
  raw: string,
  fieldLabel: string,
): unknown {
  const trimmed = raw.trim();
  if (!trimmed) {
    return null;
  }
  try {
    return JSON.parse(trimmed);
  } catch {
    throw new TypeError(`${fieldLabel} must be valid JSON.`);
  }
}

export function parseOptionalNumberField(
  raw: string,
  fieldLabel: string,
): number | null {
  const trimmed = raw.trim();
  if (!trimmed) {
    return null;
  }
  const value = Number(trimmed);
  if (!Number.isFinite(value)) {
    throw new TypeError(`${fieldLabel} must be a valid number.`);
  }
  return value;
}
